import {Typography} from "@mui/material";
import { Box } from "@mui/system";
import React, {FC} from "react"
import {StatusLabelAndColour, UserRouteStatus} from "../../models/UserClimbingEvent";

type Props = {
  id: number,
  statusLabelAndColour: StatusLabelAndColour | undefined
};
export const GridItem: FC<Props> = ({ id,statusLabelAndColour }) => {
  const icon = (statusLabelAndColour && statusLabelAndColour.status !== UserRouteStatus.NOTHING && !!statusLabelAndColour.icon) ? statusLabelAndColour.icon : undefined
  if(icon){
    return(<>
      <Typography variant={'h6'} m={1}>
      {id}
      </Typography>
        <Box p={2} sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          position: "relative",
          bottom: 35,
          left: 15,
        }}>
          <Typography variant={'h6'}>{React.createElement(icon)}</Typography>
        </Box></>
    )
  }else {
    return (
      <>
        <Typography variant='h6' sx={{p: 0.5}}>{id}</Typography>
      </>
    )
  }
}